document.addEventListener('DOMContentLoaded', () => {

    let highlights = document.querySelectorAll('.highlight-option');
    highlights.forEach(room => {
        room.addEventListener('click', function () {
            let id = room.getAttribute('data-room-id');
            if (id) {
                let details = document.querySelector(`.highlight-details[data-room-id="${id}"`);
                if (details) {
                    details.parentNode.querySelectorAll(`.highlight-details`).forEach(r => {
                        r.classList.add('hidden');
                    })
                    details.classList.remove('hidden');
                    details.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

                    details.parentNode.querySelectorAll(`.highlight-option`).forEach(r => {
                        r.classList.remove('selected');
                    })
                    room.classList.add('selected');

                }
            }
        })
    })
})

document.addEventListener('DOMContentLoaded', () => {


    const headerItems = document.querySelectorAll('.highlight-option');

    const containers = document.querySelectorAll('.community-highlights-container')





    function restructureForMobile() {
        if (containers) {

            containers.forEach(container => {
                let headers = container.querySelectorAll('.highlight-option');
                if (headers) {
                    headers.forEach(header => {
                        const index = header.getAttribute('data-room-id');
                        const content = container.querySelector(`.highlight-details[data-room-id="${index}"]`);
                        if (content) {
                            // Insert content after the header item
                            header.insertAdjacentElement('afterend', content);
                        }
                    })
                }
            })
        }
    }

    function restructureForDesktop() {
        if (containers) {

            containers.forEach(container => {
                let headers = container.querySelectorAll('.highlight-option');
                if (headers) {
                    headers.forEach(header => {
                        const index = header.getAttribute('data-room-id');
                        const content = container.querySelector(`.highlight-details[data-room-id="${index}"]`);
                        if (content) {
                            // Insert content after the header item
                            container.appendChild(content);
                        }
                    })
                }
            })
        }
    }

    function handleResize() {
        if (window.innerWidth <= 992) {
            restructureForMobile();
        } else {
            restructureForDesktop();
        }
    }


    // Initial check and resize handler
    handleResize();
    window.addEventListener('resize', handleResize);

});